import { gql } from 'graphql-request'

export namespace Task {
  export function updateTasks() {
    return gql`
      mutation updateTask($taskIds: [Int!]!, $task: TaskMutation) {
        updateTask(taskIds: $taskIds, task: $task) {
          id
          dueDate
          startTime
          endTime
          status
        }
      }
    `
  }
}
